import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./style.css";
import HeaderAddButton from "../general/pageHeader/headerAddButton";
import { FEATURE_TOGGLE_ADD_NEW_DEADLINES } from "../../config";

/**
 *  linkBack costruisce il link di sinistra che può redirigere ad altro sito quando stringa winLocation è definita
 *  mentre redirigere a una rotta del router se string pushUrl è definito
 *  Esempio
    linkBack:{
        text: "Torna alla home",
        pushUrl: "/",
        winLocation: null
     }
 */
class HeaderContent extends Component {
  static propTypes = {    
    navigate: PropTypes.any,
    isFromAccountantPage: PropTypes.any,
    location: PropTypes.any,
    linkBack: PropTypes.object,
    subtitle: PropTypes.any,
    title: PropTypes.any,
    miniHeader: PropTypes.bool,
    marginZero: PropTypes.bool,
    myType: PropTypes.string
  };

  renderLinkBackBtn() {
    const { linkBack, location } = this.props;    
    /** in presenza dell'oggetto linkBack e di un url tra pushUrl(url che causa un redirect di react router) o
     *  winLocation (url esterno al sito) allora mostro il back link
     */
    return linkBack && (linkBack.pushUrl || linkBack.winLocation) ? (
      <div
        className="linkBtn"
        onClick={el => {
          if (linkBack.actionClick) {
            linkBack.actionClick();
          }
          // se pushUrl non esiste allora sto chiedendo di andare su altro sito. window.location
          if (!linkBack.pushUrl) {
            window.location = linkBack.winLocation;
          } else {
            // se ho usato la parola magica BACK voglio pushare il link precedente
            if (linkBack.pushUrl === "BACK") {                                                       
              this.props.navigate(-1, {search: location.search});
            } else {         
              let state;               
              if (this.props?.location?.state?.scrollTop){
                state = {scrollTop: this.props.location.state.scrollTop, scrollParentTop: this.props?.location?.state?.scrollParentTop};
              } else {  
                state = {...linkBack?.nextLocation};
              }
              this.props.navigate(linkBack.pushUrl, {search: location.search, state: state});
              /*                              
              this.props.navigate(linkBack.pushUrl, this.props?.location?.state?.scrollTop ? 
                {search: location.search, state: {...location.search, scrollTop: this.props.location.state.scrollTop, scrollParentTop: this.props?.location?.state?.scrollParentTop}} : {search: location.search, state: {...location.search,...linkBack?.nextLocation}});
                */
            }
          }
        }}
      >
        <FontAwesomeIcon
          style={{ marginLeft: "20px" }}
          icon={["fal", "arrow-left"]}
        />{" "}
        <span>{linkBack.text}</span>
      </div>
    ) : (
      <div className="linkBtn" />
    );
  }

  onClickHeaderAddButton() {    
    this.props.navigate("/creascadenza");
  }

  render() {
    const {
      subtitle,
      title,
      miniHeader,
      marginZero,
      myType,
      navigate
    } = this.props;
    const isClientCard =
      myType === "STUDIO" &&
      window.location.href.indexOf("scadenzecliente") > -1;

    return (
      <div
        className={"headerPage" + (marginZero ? " marginZero" : "")}
        style={{
          height: isClientCard && 100,
          padding: isClientCard && "10px 0"
        }}
      >
        {!miniHeader && this.renderLinkBackBtn()}
        <div className="title">
          <span className="textTitle">{title}</span>
          <div className="subtitle">{subtitle}</div>
        </div>
        {isClientCard && FEATURE_TOGGLE_ADD_NEW_DEADLINES === "true" && (
          <div className="header-client-card-button-container">
            <HeaderAddButton
              navigate={navigate}
              onClick={() => this.onClickHeaderAddButton()}
              tooltip={"deadlines.tooltips.addNewDeadline"}
            />
          </div>
        )}
      </div>
    );
  }
}

export default HeaderContent;
